module.exports = __webpack_public_path__ + "img/bar-tab.16461be8.svg";